module.exports = __webpack_public_path__ + "static/img/51.871c7bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/51.png
// module id = HQu7
// module chunks = 0